import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/long-term-storage-solutions.jpg'),
    alt: 'long term storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'long term storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Long-Term <span>Storage</span><span>Solutions Available</span>',
  description:
    'Need a safe and secure place to store your belongings for an extended period? Our long-term storage solutions offer flexibility, security, and peace of mind for all your storage needs.',
  image: {
    url: '/images/v2/pages/landing-pages/long-term-storage-solutions/hero-image.jpg',
    alt: 'Long-Term Storage Solutions Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Long-Term Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Long-Term Storage Solutions Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/long-term-storage-solutions/how-our-long-term-storage-solutions-work.png',
    alt: 'How Our Long-Term Storage Solutions Work'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Storage Plans',
      description:
        'We offer a variety of long-term storage plans to suit your specific needs, from seasonal items to household goods or business inventory.',
      image: {
        src: '/images/v2/pages/landing-pages/long-term-storage-solutions/flexible-storage-plans.png',
        alt: 'Flexible Storage Plans'
      }
    },
    {
      id: 2,
      title: '24/7 Security',
      description:
        'Your belongings will be stored in our state-of-the-art facilities with 24/7 surveillance, ensuring complete peace of mind.',
      image: {
        src: '/images/v2/pages/landing-pages/long-term-storage-solutions/security.png',
        alt: '24/7 Security'
      }
    },
    {
      id: 3,
      title: 'Easy Access',
      description:
        'Access your stored items anytime, making it simple and convenient to retrieve them when you need them.',
      image: {
        src: '/images/v2/pages/landing-pages/long-term-storage-solutions/easy-access.png',
        alt: 'Easy Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Long-Term Storage Solutions',
  description:
    'Our storage solutions offer maximum security and affordability, ensuring your belongings are safe for the long term. With convenient access and flexible options, you can trust us to meet your storage needs, whether for personal items or business inventory. Experience peace of mind with our reliable services.',
  image: {
    src: '/images/v2/pages/landing-pages/long-term-storage-solutions/secure-long-term-storage-solutions.jpg',
    alt: 'Secure Long-Term Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Long-Term Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Safe and Secure Storage',
      description:
        'Our facilities are equipped with top-tier security features to protect your items for as long as you need.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Safe and Secure Storage'
      }
    },
    {
      id: 2,
      title: 'Affordable Rates',
      description:
        'Enjoy cost-effective long-term storage options with flexible pricing plans designed to fit your budget.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordable Rates'
      }
    },
    {
      id: 3,
      title: 'Convenient and Accessible',
      description:
        'Store your items with ease and access them whenever necessary, thanks to our user-friendly facilities.',
      image: {
        src: '/images/v2/pages/common/convenient-and-accessible.png',
        alt: 'Convenient and Accessible'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Long-Term Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description:
            'Store household goods, seasonal items, or furniture safely while moving, renovating, or downsizing.'
        },
        {
          id: 2,
          title: 'Business Owners',
          description:
            'Keep business inventory, equipment, or documents securely stored without taking up valuable office space.'
        },
        {
          id: 3,
          title: 'Students',
          description: 'Store personal belongings during the summer or when transitioning between school years.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/long-term-storage-solutions/who-should-use-our-long-term-storage-solutions.jpg',
        alt: 'Who Should Use Our Long-Term Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Long-Term Storage Options',

  cards: [
    {
      id: 1,
      title: 'Business Storage',
      description:
        'Store excess inventory, office documents, or equipment safely while freeing up space in your business location.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Vehicle Storage',
      description:
        'Store your car, boat, or RV securely with our long-term vehicle storage options, protecting them from the elements.',
      image: {
        src: '/images/v2/pages/common/vehicle-storage.png',
        alt: 'Vehicle Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Household Storage',
      description:
        'Securely store furniture, appliances, or other household goods during a move, renovation, or long-term travel.',
      image: {
        src: '/images/v2/pages/common/moving-box-solution.png',
        alt: 'Household Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Specialty Storage',
      description:
        'We provide tailored solutions for unique items that require special handling, including fragile items and valuable assets.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Specialty Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Your Long-Term Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/long-term-storage-solutions/why-choose-shipandstorage-for-your-long-term-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Your Long-Term Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Secure, Monitored Facilities',
      description:
        'Our state-of-the-art storage facilities offer the latest in security technology, keeping your items safe at all times.'
    },
    {
      id: 2,
      title: 'Variety of Storage Options',
      description:
        'Whether you’re storing a few items or an entire home’s worth of goods, we offer options for all sizes and types of items.'
    },
    {
      id: 3,
      title: 'Affordable Pricing',
      description: 'We offer competitive rates for long-term storage, with no hidden fees and flexible payment options.'
    },
    {
      id: 4,
      title: 'Peace of Mind',
      description:
        'Our comprehensive solutions provide you with the security and convenience you need, allowing you to rest easy.'
    },
    {
      id: 5,
      title: 'Convenient Access',
      description: 'Access your belongings whenever needed, with facilities designed for easy retrieval.'
    },
    {
      id: 6,
      title: 'Personalized Customer Service',
      description:
        'Our team is here to support you every step of the way, ensuring you have a smooth and hassle-free storage experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Long-Term Storage Solutions for Personal and Business',
  description:
    'Long-term storage solutions available. Affordable and secure options for storing your personal or business items safely over extended periods.',
  image: {
    src: '/images/v2/pages/landing-pages/long-term-storage-solutions/long-term-storage-solutions-for-personal-and-business.png',
    alt: 'Long-Term Storage Solutions for Personal and Business'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description:
    'We work with top logistics providers to ensure your items are shipped safely and efficiently, whether you need to ship them to our storage facilities or retrieve them later.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers fast and reliable shipping services, ensuring your items are delivered safely to our storage facilities.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure and timely shipping services, ensuring your goods are handled with care, whether domestic or international.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers reliable shipping options for both local and international deliveries, ensuring your belongings are safely transported to our storage facilities.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
